const bg_selected = "bg-[#F4C082]";
const bg_not_selected = "bg-[#FFEAB5]";
const teaspoonSelects = document.querySelectorAll(".teaspoon-select");
const quantityInputs = document.querySelectorAll(".quantity-input");
const filter = document.querySelectorAll("#filter");
const TeaspoonList = [
  {
    label: `少々`,
    value: "0.1",
  },
  {
    label: `1/4`,
    value: "0.25",
  },
  {
    label: `1/3`,
    value: "0.33",
  },
  {
    label: `1/2`,
    value: "0.5",
  },
  {
    label: `1`,
    value: "1.0",
  },
  {
    label: `1.5`,
    value: "1.5",
  },
  {
    label: `2`,
    value: "2.0",
  },
  {
    label: `2.5`,
    value: "2.5",
  },
  {
    label: `3`,
    value: "3.0",
  },
];

quantityInputs.forEach((quantityInput, index) => {
  quantityInput.value = "";
  quantityInput.addEventListener("change", function () {
    quantityInputs[index].value = parseFloat(quantityInput.value).toFixed(1);
  });
});
quantityInputs.forEach((quantityInput, index) => {
  quantityInput.value = "";
  quantityInput.addEventListener("input", function () {
    var selectedQuantity = parseFloat(quantityInput.value).toFixed(1);
    var foundMatch = false;
    teaspoonSelects.forEach(function (teaspoonSelect, currentIndex) {
      if (currentIndex === index) {
        for (var i = 0; i < teaspoonSelect.options.length; i++) {
          var option = teaspoonSelect.options[i];

          if (parseFloat(option.value).toFixed(1) === selectedQuantity) {
            teaspoonSelect.value = option.value;
            foundMatch = true;
            break;
          }
        }

        if (!foundMatch) {
          teaspoonSelect.value = "";
        }
      }
    });

    var productId = quantityInput.getAttribute("data-product-id");
    var allAddToPackageBtns = document.querySelectorAll(".addToPackageBtn");
    allAddToPackageBtns.forEach(function (addToPackageBtn) {
      var buttonId = addToPackageBtn.getAttribute("data-product-id");
      if (quantityInput.value.trim() != "0") {
        addToPackageBtn.disabled = buttonId == productId ? false : true;
      } else {
        addToPackageBtn.disabled = true;
      }
    });
  });
});

function MapPackageToPopupValue(id) {
  const teaspoonPopup = document.getElementById(
    `package-popup--teaspoon-${id}`
  );
  const quantityPopup = document.getElementById(
    `package-popup--quantity-${id}`
  );
  const teaspoonPackage = document.getElementById(`teaspoon-${id}`);
  const quantityPackage = document.getElementById(`quantity-${id}`);

  teaspoonPopup.value = teaspoonPackage.value;
  quantityPopup.value = quantityPackage.value;
}

function MapPopupToPackageValue(id) {
  const teaspoonPopup = document.getElementById(
    `package-popup--teaspoon-${id}`
  );
  const quantityPopup = document.getElementById(
    `package-popup--quantity-${id}`
  );
  const teaspoonPackage = document.getElementById(`teaspoon-${id}`);
  const quantityPackage = document.getElementById(`quantity-${id}`);

  teaspoonPackage.value = teaspoonPopup.value;
  quantityPackage.value = quantityPopup.value;
}

function teaspoonPackageChange(id) {
  const teaspoonSelect = document.getElementById(`teaspoon-${id}`);
  const quantityInput = document.getElementById(`quantity-${id}`);
  const selectedTeaspoon = teaspoonSelect.value;
  quantityInput.value = parseFloat(selectedTeaspoon).toFixed(1);
  checkQuantity(quantityInput);
  MapPackageToPopupValue(id);
}

function resetQuantity() {
  teaspoonSelects.forEach((teaspoonSelect, index) => {
    teaspoonSelect.value = "0";
    const selectedTeaspoon = teaspoonSelect.value;
    quantityInputs[index].value = parseFloat(selectedTeaspoon);
  });
  var allAddToPackageBtns = document.querySelectorAll(".addToPackageBtn");

  allAddToPackageBtns.forEach(function (addToPackageBtn) {
    addToPackageBtn.disabled = true;
  });

  quantityInputs.forEach((quantityInput, index) => {
    quantityInput.value = "";
    teaspoonSelects[index].value = "0";
  });
}

function FocusInInput(id) {
  document.querySelectorAll(".addToPackageBtn").forEach(function (btn) {
    btn.disabled = true;
  });
  document.getElementById(`add-to-package-${id}`).disabled = false;
}


function checkQuantity(input) {
  var quantityInput = input;
  const floatValue = parseFloat(quantityInput.value).toFixed(1);
  if (isNaN(floatValue) || floatValue < 0.1) {
    quantityInput.value = 0;
  } else if (floatValue > 50) {
    quantityInput.value = 50;
  } else quantityInput.value = floatValue;

  var productId = quantityInput.getAttribute("data-product-id");
  var allAddToPackageBtns = document.querySelectorAll(".addToPackageBtn");

  allAddToPackageBtns.forEach(function (addToPackageBtn) {
    var buttonId = addToPackageBtn.getAttribute("data-product-id");
    if (quantityInput.value.trim() != "0") {
      addToPackageBtn.disabled = buttonId == productId ? false : true;
    } else {
      addToPackageBtn.disabled = true;
    }
  });
  MapPackageToPopupValue(productId);
}

function fullWidthNumConvert(fullWidthNum) {
  let halfWidthNum = fullWidthNum.replace(/[\uFF10-\uFF19]/g, function (m) {
    if (m.charCodeAt(0) >= 0xff10 && m.charCodeAt(0) <= 0xff19) {
      return String.fromCharCode(m.charCodeAt(0) - 0xfee0);
    } else {
      return m;
    }
  });

  halfWidthNum = halfWidthNum.replace(/[、．。]/g, ".");
  return halfWidthNum;
}

function ValidateInputFloatNumber(inputElement) {
  const id = inputElement.getAttribute("data-product-id");
  localStorage.setItem(`isChooseGram-${id}`, true);
  inputElement.value = fullWidthNumConvert(inputElement.value);
  inputElement.value = inputElement.value
    .replace(/[^0-9.]/g, "")
    .replace("00", "0");

  var productId = inputElement.getAttribute("data-product-id");
  var allAddToPackageBtns = document.querySelectorAll(".addToPackageBtn");

  allAddToPackageBtns.forEach(function (addToPackageBtn) {
    var buttonId = addToPackageBtn.getAttribute("data-product-id");
    if (inputElement.value.trim() != "0") {
      addToPackageBtn.disabled = buttonId == productId ? false : true;
    } else {
      addToPackageBtn.disabled = true;
    }
  });
}

// function FocusInputFloatNumber(inputElement) {
//   inputElement.value = fullWidthNumConvert(inputElement.value);
//   inputElement.value = inputElement.value
//     .replace(/[^0-9.]/g, "")
//     .replace("00", "0");
//   let dotCount = inputElement.value.split(".").length - 1;
//   if (dotCount > 1) inputElement.value = inputElement.value.slice(0, -1);
// }

function ValidatePopupInput(inputElement) {
  inputElement.value = fullWidthNumConvert(inputElement.value);
  inputElement.value = inputElement.value
    .replace(/[^0-9.]/g, "")
    .replace("00", "0");
  let dotCount = inputElement.value.split(".").length - 1;
  if (dotCount > 1) inputElement.value = inputElement.value.slice(0, -1);

  const floatValue = parseFloat(inputElement.value).toFixed(1);
  HiddenPopupError();
  if (isNaN(floatValue) || floatValue < 0.1) ShowPopupError();
  var decimalPart = inputElement.value.split(".")[1];
  if (decimalPart && decimalPart.length > 1) ShowPopupError();
}

function ShowPopupError() {
  const all_error = document.querySelectorAll(`.edit-popup--error`);
  const all_btn_add = document.querySelectorAll(`.edit-popup--btn-add`);
  all_error.forEach(function (error) {
    error.style.display = "flex";
  });
  all_btn_add.forEach(function (btn_add) {
    btn_add.disabled = true;
  });
}

function HiddenPopupError() {
  const all_error = document.querySelectorAll(`.edit-popup--error`);
  const all_btn_add = document.querySelectorAll(`.edit-popup--btn-add`);
  all_error.forEach(function (error) {
    error.style.display = "none";
  });
  all_btn_add.forEach(function (btn_add) {
    btn_add.disabled = false;
  });
}

function SelectByGam(id) {
  localStorage.setItem(`isChooseGram-${id}`, true);
  const select_by_gam = document.getElementById(`package--select-gam-${id}`);
  const select_by_teaspoon = document.getElementById(
    `package--select-teaspoon-${id}`
  );
  const tab_gam = document.getElementById(`package--tab-gam-${id}`);
  const tab_teaspoon = document.getElementById(`package--tab-teaspoon-${id}`);
  select_by_gam.style.display = "flex";
  select_by_teaspoon.style.display = "none";
  tab_gam.classList.remove(bg_not_selected);
  tab_gam.classList.add(bg_selected);
  tab_teaspoon.classList.remove(bg_selected);
  tab_teaspoon.classList.add(bg_not_selected);
}

function SelectByTeaspoon(id) {
  localStorage.setItem(`isChooseGram-${id}`, false);
  const select_by_gam = document.getElementById(`package--select-gam-${id}`);
  const select_by_teaspoon = document.getElementById(
    `package--select-teaspoon-${id}`
  );
  const tab_gam = document.getElementById(`package--tab-gam-${id}`);
  const tab_teaspoon = document.getElementById(`package--tab-teaspoon-${id}`);
  select_by_gam.style.display = "none";
  select_by_teaspoon.style.display = "flex";
  tab_teaspoon.classList.remove(bg_not_selected);
  tab_teaspoon.classList.add(bg_selected);
  tab_gam.classList.remove(bg_selected);
  tab_gam.classList.add(bg_not_selected);
}

function SelectByGamPackage(id) {
  localStorage.setItem(`isChooseGram-${id}`, true);
  const select_by_gam = document.getElementById(
    `package-popup--select-gam-${id}`
  );
  const select_by_teaspoon = document.getElementById(
    `package-popup--select-teaspoon-${id}`
  );
  const tab_gam = document.getElementById(`package-popup--tab-gam-${id}`);
  const tab_teaspoon = document.getElementById(
    `package-popup--tab-teaspoon-${id}`
  );
  select_by_gam.style.display = "flex";
  select_by_teaspoon.style.display = "none";
  tab_gam.classList.remove(bg_not_selected);
  tab_gam.classList.add(bg_selected);
  tab_teaspoon.classList.remove(bg_selected);
  tab_teaspoon.classList.add(bg_not_selected);
}

function SelectByTeaspoonPackage(id) {
  localStorage.setItem(`isChooseGram-${id}`, false);
  const select_by_gam = document.getElementById(
    `package-popup--select-gam-${id}`
  );
  const select_by_teaspoon = document.getElementById(
    `package-popup--select-teaspoon-${id}`
  );
  const tab_gam = document.getElementById(`package-popup--tab-gam-${id}`);
  const tab_teaspoon = document.getElementById(
    `package-popup--tab-teaspoon-${id}`
  );
  select_by_gam.style.display = "none";
  select_by_teaspoon.style.display = "flex";
  tab_teaspoon.classList.remove(bg_not_selected);
  tab_teaspoon.classList.add(bg_selected);
  tab_gam.classList.remove(bg_selected);
  tab_gam.classList.add(bg_not_selected);
}

function ShowPopupSpice(id) {
  document.body.classList.add("overflow-hidden");
  document
    .getElementById(`package--edit-model-${id}`)
    .classList.remove("hidden");
}
function HiddenPopupSpice(id) {
  document.body.classList.remove("overflow-hidden");
  document
    .getElementById(`package--edit-model-${id}`)
    .classList.add("hidden");
}

function TeaspoonChangePackage(id) {
  const teaspoonSelect = document.getElementById(
    `package-popup--teaspoon-${id}`
  );
  const quantityInput = document.getElementById(
    `package-popup--quantity-${id}`
  );
  const selectedTeaspoon = teaspoonSelect.value;
  quantityInput.value = parseFloat(selectedTeaspoon);
  HiddenPopupError();
  MapPopupToPackageValue(id);
}

function QuantityChangePackage(id) {
  localStorage.setItem(`isChooseGram-${id}`, true);
  const teaspoonSelect = document.getElementById(
    `package-popup--teaspoon-${id}`
  );
  const quantityInput = document.getElementById(
    `package-popup--quantity-${id}`
  );
  const floatValue = parseFloat(quantityInput.value).toFixed(1);
  if (isNaN(floatValue) || floatValue < 0.1) {
    quantityInput.value = 0.1;
  } else if (floatValue > 50) {
    quantityInput.value = 50;
  } else quantityInput.value = floatValue;

  var selectedQuantity = parseFloat(quantityInput.value).toFixed(1);
  var foundMatch = false;
  for (var i = 0; i < teaspoonSelect.options.length; i++) {
    var option = teaspoonSelect.options[i];
    if (option.value === selectedQuantity) {
      teaspoonSelect.value = option.value;
      foundMatch = true;
      break;
    }
  }
  if (!foundMatch) {
    teaspoonSelect.value = "";
  }
  HiddenPopupError();
  MapPopupToPackageValue(id);
}

function AddPopupToDraftCart(id, teaspoons_value, is_buy_one, messageError) {
  const numberSpiceAdded = localStorage.getItem("draft_cart");
  if (numberSpiceAdded) {
    let draftCart = JSON.parse(numberSpiceAdded);
    if (draftCart.length >= 10) {
      createToast("error", messageError);
      return;
    }
  }
  const popupTeaspoon = document.getElementById(
    `package-popup--teaspoon-${id}`
  );
  const popupQuantity = document.getElementById(
    `package-popup--quantity-${id}`
  );
  const packageTeaspoon = document.getElementById(`teaspoon-${id}`);
  const packageQuantity = document.getElementById(`quantity-${id}`);

  packageTeaspoon.value = popupTeaspoon.value;
  packageQuantity.value = popupQuantity.value;

  const btn_add = document.getElementById(id);
  btn_add.disabled = true;

  HiddenPopupSpice(id);
  AddToPackage(id, teaspoons_value, is_buy_one);
}

function goBack() {}

function updateCheckboxAllState() {
  var allChecked = true;
  $(".filter-spice-item").each(function () {
    if (!$(this).is(":checked")) {
      allChecked = false;
      return false;
    }
  });
  $("#checkbox-all").prop("checked", allChecked);
}

function updateResetButtonState() {
  var anyChecked = false;
  $(".filter-spice-item").each(function () {
    if ($(this).is(":checked")) {
      anyChecked = true;
      return false;
    }
  });
  $("#filter-spice-reset").prop("disabled", !anyChecked);
}

$("#checkbox-all").click(function () {
  var isChecked = $(this).is(":checked");
  $(".filter-spice-item").prop("checked", isChecked);
  updateResetButtonState();
});

$(".filter-spice-item").click(function () {
  updateCheckboxAllState();
  updateResetButtonState();
});

$("#filter-spice-reset").click(function () {
  $(".filter-spice-item").prop("checked", false);
  $("#checkbox-all").prop("checked", false);
  $(this).prop("disabled", true);
});

updateCheckboxAllState();
updateResetButtonState();

const checkFilter = () => {
  let anyChecked = false;
  let numChecked = 0;
  let numProducts = $("#productCount").data("count");
  ShowLoadingPage();

  $(".filter-spice-item").each(function () {
    let id = $(this).data("id");
    if ($(this).is(":checked")) {
      anyChecked = true;
      numChecked += 1;
      $("#item-" + id)
        .removeClass("hidden")
        .addClass("block");
      $("#filter-spice-reset").prop("disabled", false);
    } else {
      $("#item-" + id)
        .removeClass("block")
        .addClass("hidden");
    }
  });

  if (numChecked == numProducts) {
    $("#checkbox-all").prop("checked", true);
  }

  let spices = $("#productCount").data("type");

  $("#productCount").html(
    numChecked + " " + spices
    //+(numChecked > 1 ? "s" : "")
  );

  if (!anyChecked) {
    let error = $("#filter-error").data("error");
    $("#filter-error").html(
      `<p class="type--heading title--medium type--hyphenate text-center text-2xl text-gray-500 ml-0 mt-10">${error}</p>`
    );
  } else {
    $("#filter-error").html("");
  }

  var products_per_page = $("#products_per_page").val();
  if (numChecked < parseInt(products_per_page)) {
    $("#ProductGridContainer .pagination").hide();
  } else {
    $("#ProductGridContainer .pagination").show();
  }

  setTimeout(() => {
    HiddenLoadingPage();
    $("#dropdownFilter").toggleClass("hidden");
  }, 200);
};

$("#filterInput").click(function () {
  if ($("#dropdownFilter").is(":visible")) {
    $("#dropdownFilter").hide();
  } else {
    $("#dropdownFilter").show();
  }
});
